import { useEffect, useState } from "react"
import type { LoaderFunctionArgs, MetaFunction } from "react-router"
import { Links, Meta, Outlet, Scripts, ScrollRestoration } from "react-router"

import "@/styles/global.scss"

export const loader = ({ request }: LoaderFunctionArgs) => {
  const url = new URL(request.url)
  const domain = url.origin

  // 動的に生成されたOGイメージURL
  const ogImageUrl = `${domain}/ogimg.png`

  return { ogImageUrl }
}

export const meta: MetaFunction<typeof loader> = ({ data }) => {
  const title = "コタエルHR"
  const description =
    "コタエルHRは人と組織にまつわる課題を解決し、成長を目指す企業の未来をつくります。さまざまなHRサービスの提供を通じて、組織の進化を加速させます。"

  // この値はextractRootOgImageUrl関数で参照しているので、削除の際は注意
  const ogImageUrl = data?.ogImageUrl

  /*
   * 下記は、各route内でmetaを定義し忘れてしまった場合のフォールバック設定、という立ち位置になります
   * (=最後にマッチしたrouteのmetaのみが適用されるため)
   */
  return [
    { title: title },
    { name: "description", content: description },
    { property: "og:title", content: title },
    { property: "og:description", content: description },
    { property: "og:image", content: ogImageUrl },
    { property: "og:type", content: "website" },
  ]
}

export function Layout() {
  const [isGtmScriptAdded, setIsGtmScriptAdded] = useState(false)
  const GtmId = "GTM-TS9PQKZD"

  useEffect(() => {
    if (isGtmScriptAdded) {
      return
    }
    addGtmScript(GtmId)
    setIsGtmScriptAdded(true)
  }, [])

  return (
    <html lang="ja">
      <head>
        <meta httpEquiv="Content-Type" content="text/html; charset=UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="preconnect" href="https://fonts.gstatic.com/" />
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@100..900&display=swap"
        />
        <link rel="icon" type="image/png" href="/favicon.png" />
        <Meta />
        <Links />
      </head>
      <body className="text-main">
        <noscript>
          {/* biome-ignore lint/a11y/useIframeTitle: <explanation> */}
          <iframe
            src={`https://www.googletagmanager.com/ns.html?id=${GtmId}`}
            height="0"
            width="0"
            style={{ display: "none", visibility: "hidden" }}
          />
        </noscript>

        <Outlet />
        <ScrollRestoration />
        <Scripts />
      </body>
    </html>
  )
}

export default function App() {
  return <Outlet />
}

declare global {
  interface Window {
    [key: string]: object[]
  }
}

function addGtmScript(GtmId: string) {
  // Code copied from GTM console + added type annotations.
  // biome-ignore lint/complexity/useArrowFunction:
  ;(function (w: Window, d: Document, s: "script", l: string, i: string) {
    w[l] = w[l] || []
    w[l].push({
      // biome-ignore lint/complexity/useDateNow:
      "gtm.start": new Date().getTime(),
      event: "gtm.js",
    })
    const f = d.getElementsByTagName(s)[0]
    const j = d.createElement<"script">(s)
    const dl = l !== "dataLayer" ? `&l=${l}` : ""
    j.async = true
    j.src = `https://www.googletagmanager.com/gtm.js?id=${i}${dl}`
    f.parentNode?.insertBefore(j, f)
  })(window, document, "script", "dataLayer", GtmId)
}
